/* eslint-disable max-len */
import jDashHubin from '@/views/dashboard/jDashHubin';

import jMitraList from '@/views/hubungan-dinas/mitra/jMitraList';
import jPengumumanList from '@/views/hubungan-dinas/pengumuman/jPengumumanList';
import jBukuTamuList from '@/views/hubungan-dinas/buku-tamu/jBukuTamuList';

import auth from '@/middleware/auth';
import log from '@/middleware/log';

export default [
  {
    path: '/dashboard/hubin',
    name: 'jDashHubin',
    component: jDashHubin,
    meta: {
      title: 'Dashboard Hubingan Dinas',
      middleware: [auth, log],
      layout: 'jHomeWrapper',
    },
  },

  {
    path: '/mitra',
    name: 'jMitraList',
    component: jMitraList,
    meta: {
      title: 'Administrasi Mitra',
      middleware: [auth, log],
      layout: 'jHomeWrapper',
    },
  },
  {
    path: '/pengumuman',
    name: 'jPengumumanList',
    component: jPengumumanList,
    meta: {
      title: 'Administrasi Pengumuman',
      middleware: [auth, log],
      layout: 'jHomeWrapper',
    },
  },
  {
    path: '/buku-tamu',
    name: 'jBukuTamuList',
    component: jBukuTamuList,
    meta: {
      title: 'Administrasi Buku Tamu',
      middleware: [auth, log],
      layout: 'jHomeWrapper',
    },
  },
];



// WEBPACK FOOTER //
// ./src/router/jRouterHubin.js